import {Injectable} from '@angular/core';
import {UtilsService} from '../../utils/utils.service';
import {Auth2Service} from '../security/auth2.service';
import {FormFieldTextboxSupplier} from '../../suppliers/form-field-textbox-supplier';
import {FormFieldCheckboxSupplier} from '../../suppliers/form-field-checkbox-supplier';
import {FormFieldBaseSupplier} from '../../suppliers/form-fieldbase-supplier';
import {GenericHandler} from '../generics/generic-handler';
import {HttpClient} from '@angular/common/http';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {ZoneDeProductionDTO} from '../../dtos/zone-de-production-dto';
import {DialogMsgSupplier} from '../../suppliers/dialog-msg-supplier';
import {ObjectDTO} from '../../dtos/object-dto';
import {startCase as _startCase} from 'lodash';
import {GenericDatagridService} from '../generics/generic-datagrid.service';
import {catchError} from 'rxjs/operators';


@Injectable()
export class ZonesDeProductionService extends GenericHandler<ZoneDeProductionDTO> {

  getTotalRecordsLabel(): string {
    return _startCase('Ateliers');
  }


  getHelp(): DialogMsgSupplier {
    return undefined;
  }

  getSort(): string[] {
    return ['code,asc'];
  }

  getOas(): boolean {
    return undefined;
  }

  getTitle(): string {
    return 'GESTION DES ATELIERS';
  }

  getCreateNewObjectLabel(): string {
    return 'CRÉER UN ATELIER';
  }


  constructor(utils: UtilsService, auth2Svc: Auth2Service,
              router: Router, http: HttpClient, title: Title, private gds: GenericDatagridService) {
    super(utils, auth2Svc, router, http, title);
  }

  getEntityName(): string {
    return 'zoneDeProduction';
  }

  getFields(dto: ZoneDeProductionDTO): FormFieldBaseSupplier<any>[] {

    // Par défaut une ZoneDeProduction est active.
    if (this.utils.isNullOrEmpty(dto) || dto.id == 0 || dto.id == undefined) {
      dto = new ZoneDeProductionDTO();
      dto.actif = true;
    }

    const formFields: FormFieldBaseSupplier<any>[] = [

      this.createFormFieldBaseSupplierForSite(dto, 1),

      new FormFieldTextboxSupplier({
        key: 'libelle',
        label: 'Libellé',
        readonly: !this.canModify(dto),
        minLength: 2,
        maxLength: 100,
        value: dto.libelle,
        required: true,
        excelType: 'string',
        order: 2
      }),

      new FormFieldTextboxSupplier({
        key: 'code',
        label: 'Code',
        readonly: !this.canModify(dto),
        value: dto.code,
        maxLength: 50,
        required: true,
        excelType: 'string',
        order: 3
      }),

      new FormFieldCheckboxSupplier({
        key: 'actif',
        label: 'Actif',
        readonly: !this.canModify(dto),
        value: dto.actif,
        excelType: 'boolean',
        required: false,
        order: 5
      }),

      new FormFieldTextboxSupplier({
        key: 'id',
        type: 'hidden',
        value: dto.id,
        order: 6
      })

    ];

    return formFields.sort((a, b) => a.order - b.order);
  }


  getAllFromEnvironnement(): void {
  }

  createEmptyDTO(): ZoneDeProductionDTO {
    return new ZoneDeProductionDTO();
  }

  getEditObjectLabel(data: ObjectDTO): string {
    return `MODIFIER L'ATELIER '${data.libelle.toUpperCase()}'`;
  }

  getAll() {
    return this.gds.getAll(this.getEntityName(), ['code,asc'], true)
      .pipe(
        catchError(err => this.utils.handleError(err, true))
      );
  }

}
